import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import Button from '@shared/ui/button'
import {
  Form,
} from '@shared/ui/form'
import { PHONE_MASK_LENGTH } from '@shared/validation'

import DeliveryAddressFormFields from './fields'

import styles from './styles.module.scss'

interface DeliveryAddressFormProps {
  isLoading?: boolean;
  onSubmit: (values: z.infer<typeof formSchema>) => void;
  isZone: boolean;
}

export interface FormValues {
  apartment?: string;
  floor?: string;
  entrance?: string;
  intercom?: string;
  comment?: string;
  title?: string;
  otherBuyer?: boolean;
  otherBuyerName?: string;
  otherBuyerPhone?: string;
}

const formSchema = z
  .object({
    apartment: z.string().optional(),
    floor: z.string().optional(),
    entrance: z.string().optional(),
    intercom: z.string().optional(),
    comment: z.string().optional(),
    title: z.string().optional(),
    otherBuyer: z.boolean().optional(),
    otherBuyerName: z.string().optional(),
    otherBuyerPhone: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.otherBuyer) {
      if (!data.otherBuyerName?.trim()) {
        ctx.addIssue({
          path: [ 'otherBuyerName' ],
          code: z.ZodIssueCode.custom,
          message: 'Обязательное поле',
        })
      }
      if ((data.otherBuyerPhone?.trim().length ?? 0) < PHONE_MASK_LENGTH) {
        ctx.addIssue({
          path: [ 'otherBuyerPhone' ],
          code: z.ZodIssueCode.custom,
          message: 'Неверный номер',
        })
      }
    }
  })

export default function DeliveryAddressForm ({
  isLoading,
  onSubmit,
  isZone,
}: DeliveryAddressFormProps) {
  const { t: tc } = useTranslation('common')

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      apartment: '',
      floor: '',
      entrance: '',
      intercom: '',
      comment: '',
      title: '',
      otherBuyer: false,
      otherBuyerName: '',
      otherBuyerPhone: '',
    },
  })

  return (
    <div className={styles.root}>
      <Form {...form}>
        <form
          className={styles.root__form}
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <DeliveryAddressFormFields control={form.control} />

          <Button
            className={styles.root__submit}
            type="submit"
            size="large"
            disabled={isLoading || !isZone}
          >
            {tc('save')}
          </Button>
        </form>
      </Form>
    </div>
  )
}
